
const projects = [
  {
    name: 'Personas and Storyboarding',
    description:
      'This is a project based around modelling potential users as personas and seeing how they interact with the interfaces we design. I created multiple personas and explored how they might interact with a simple water fountain.',
    stack: ['localstorage', 'Openweather API', 'Google Map API','Movie Database API'],
    image: '/images/Personas.PNG',
    link: 'https://trashiestpanda666.github.io/CS-1300-Persona/'
  },
  {
    name: 'Responsive Redesign',
    description:
      'I visited an old website in order to recognize and critique its flaws. Then, I redesigned the website using core design principles to create an interactive mockup of the final product.',
    stack: ['swiper.js', 'npm', 'jawsdb','handlebars','express','nodejs'],
    image: '/images/ResponsiveRedesign.PNG',
    link: 'https://trashiestpanda666.github.io/Responsive_Redesign_Deploy/'
  },
  {
    name: 'Iterative Design',
    description:
      'We took a look at startups to see how we could design an interface that effectively communicates their mission, purpose, and story. This project was an interative process in which we explored how to incorporate feedback and critique.',
    stack: ['html-css-javascript', 'sequelize', 'React'],
    image: '/images/IterativeDesign.PNG',
    link: 'https://maladjustedcarp401.github.io/Iterative_Design/'
  },
  {
    name: 'Development',
    description:
      'This was an app development excercise done in React. This website supports functionality that allows users to filter through items, sort them by price, and add them to a cart',
    stack: ['Java 8', 'MySQL', 'React'],
    image: '/images/Development.PNG',
    link: 'https://trashiestpanda666.github.io/DevelopmentActual2/',
  },
]

export {projects}
